export type AssignableAdminRole =
  | 'team-lead'
  | 'inspector'
  | 'safety-coordinator';

export type AdminUser = {
  userId: string;
  email?: string;
  name?: string;
  roles: string[];
};

export type CreateAdminUserPayload = {
  email: string;
  password: string;
  roles: AssignableAdminRole[];
};

export const ASSIGNABLE_ADMIN_ROLE_OPTIONS: Array<{
  value: AssignableAdminRole;
  label: string;
}> = [
  { value: 'team-lead', label: 'Teamledare' },
  { value: 'inspector', label: 'Kontrollant' },
  { value: 'safety-coordinator', label: 'Säkerhetssamordnare' },
];
